import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Treasury = () => {
  const [treasury, setTreasury] = useState([]);
  const [log, setLog] = useState([]);
  const [showDepositForm, setShowDepositForm] = useState(false);
  const [showWithdrawForm, setShowWithdrawForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [filterSource, setFilterSource] = useState('all');
  const [filterType, setFilterType] = useState('all');
  const [filterCurrency, setFilterCurrency] = useState('all');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [form, setForm] = useState({ currency_code: 'IQD', amount: '', notes: '' });
  const token = localStorage.getItem('token');

  const currencyList = ['IQD', 'USD', 'EUR', 'GBP', 'SAR', 'AED', 'TRY', 'CAD'];

  useEffect(() => { fetchTreasury(); }, []);

  const fetchTreasury = async () => {
    try {
      const response = await axios.get('https://app.hayahost.net/api/treasury', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTreasury(response.data.treasury);
      setLog(response.data.log);
    } catch (err) { console.error(err); }
  };

  const handleDeposit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('https://app.hayahost.net/api/treasury/deposit', form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setShowDepositForm(false);
      setForm({ currency_code: 'IQD', amount: '', notes: '' });
      fetchTreasury();
      alert('تم الإيداع بنجاح!');
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const handleWithdraw = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('https://app.hayahost.net/api/treasury/withdraw', form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setShowWithdrawForm(false);
      setForm({ currency_code: 'IQD', amount: '', notes: '' });
      fetchTreasury();
      alert('تم السحب بنجاح!');
    } catch (err) { alert('الرصيد غير كافٍ!'); }
    setLoading(false);
  };

  const formatDateTime = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return `${d.toLocaleDateString('ar-IQ')} ${d.toLocaleTimeString('ar-IQ', {hour: '2-digit', minute: '2-digit'})}`;
  };

  const getTypeLabel = (type) => {
    const types = {
      'in': { label: '📥 دخول', color: '#2e7d32' },
      'out': { label: '📤 خروج', color: '#c62828' },
      'profit': { label: '💰 ربح', color: '#1565c0' },
      'deposit': { label: '🏦 إيداع', color: '#2e7d32' },
      'withdraw': { label: '💸 سحب', color: '#c62828' },
    };
    return types[type] || { label: type, color: '#333' };
  };

  const getSourceLabel = (source) => {
    const sources = {
      'exchange': '💱 صرافة',
      'transfer': '💸 حوالة',
      'transfer_delivery': '💸 تسليم حوالة',
      'debt': '📋 مديونية',
      'manual': '✋ يدوي',
      'customer_account': '📒 حساب عميل',
      'client_payment': '🏦 تسديد فرع',
      'client_balance': '💰 رصيد فرع',
    };
    return sources[source] || source;
  };

  const filteredLog = log.filter(l => {
    if (filterSource !== 'all' && l.source !== filterSource) return false;
    if (filterType !== 'all' && l.type !== filterType) return false;
    if (filterCurrency !== 'all' && l.currency_code !== filterCurrency) return false;
    if (fromDate && new Date(l.created_at) < new Date(fromDate)) return false;
    if (toDate && new Date(l.created_at) > new Date(toDate + 'T23:59:59')) return false;
    if (search) {
      const s = search.toLowerCase();
      return (
        l.notes?.toLowerCase().includes(s) ||
        l.currency_code?.toLowerCase().includes(s) ||
        l.username?.toLowerCase().includes(s) ||
        String(l.amount).includes(s)
      );
    }
    return true;
  });

  const totalIn = filteredLog.filter(l => ['in', 'deposit', 'profit'].includes(l.type)).reduce((s, l) => s + parseFloat(l.amount), 0);
  const totalOut = filteredLog.filter(l => ['out', 'withdraw'].includes(l.type)).reduce((s, l) => s + parseFloat(l.amount), 0);

  return (
    <div style={styles.container}>
      <div style={styles.navbar}>
        <h1 style={styles.navTitle}>🏦 نظام الحوالات والصيرفة</h1>
        <button style={styles.logoutBtn} onClick={() => { localStorage.clear(); window.location.href = '/login'; }}>خروج</button>
      </div>

      <div style={styles.layout}>
        <div style={styles.sidebar}>
          <a href="/" style={styles.sideItem}>🏠 الرئيسية</a>
          <a href="/customers" style={styles.sideItem}>👥 العملاء</a>
          <a href="/transfers" style={styles.sideItem}>💸 الحوالات</a>
          <a href="/exchange" style={styles.sideItem}>💱 الصرافة</a>
          <a href="/debts" style={styles.sideItem}>📋 المديونيات</a>
          <a href="/treasury" style={{...styles.sideItem, background: '#e3f2fd', color: '#1a237e', fontWeight: 'bold'}}>🏛️ القاصة</a>
          <a href="/accounts" style={styles.sideItem}>📒 حسابات العملاء</a>
          <a href="/clients" style={styles.sideItem}>🔐 إدارة الفروع</a>
          <a href="/reports" style={styles.sideItem}>📊 التقارير</a>
        </div>

        <div style={styles.content}>

          {/* أرصدة القاصة */}
          <div style={styles.section}>
            <div style={styles.header}>
              <h2 style={styles.pageTitle}>🏛️ أرصدة القاصة</h2>
              <div style={{display: 'flex', gap: '10px'}}>
                <button style={styles.depositBtn} onClick={() => { setShowDepositForm(!showDepositForm); setShowWithdrawForm(false); }}>
                  📥 إيداع
                </button>
                <button style={styles.withdrawBtn} onClick={() => { setShowWithdrawForm(!showWithdrawForm); setShowDepositForm(false); }}>
                  📤 سحب
                </button>
              </div>
            </div>

            {showDepositForm && (
              <div style={styles.formCard}>
                <h3 style={styles.formTitle}>📥 إيداع في القاصة</h3>
                <form onSubmit={handleDeposit}>
                  <div style={styles.formGrid}>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>العملة</label>
                      <select style={styles.input} value={form.currency_code} onChange={e => setForm({...form, currency_code: e.target.value})}>
                        {currencyList.map(c => <option key={c} value={c}>{c}</option>)}
                      </select>
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>المبلغ</label>
                      <input style={styles.input} type="number" value={form.amount} onChange={e => setForm({...form, amount: e.target.value})} placeholder="0" required />
                    </div>
                    <div style={{...styles.inputGroup, gridColumn: 'span 2'}}>
                      <label style={styles.label}>ملاحظات</label>
                      <input style={styles.input} value={form.notes} onChange={e => setForm({...form, notes: e.target.value})} placeholder="سبب الإيداع" />
                    </div>
                  </div>
                  <button style={styles.submitBtn} type="submit" disabled={loading}>
                    {loading ? 'جاري الإيداع...' : '📥 تأكيد الإيداع'}
                  </button>
                </form>
              </div>
            )}

            {showWithdrawForm && (
              <div style={{...styles.formCard, borderRight: '4px solid #c62828'}}>
                <h3 style={{...styles.formTitle, color: '#c62828'}}>📤 سحب من القاصة</h3>
                <form onSubmit={handleWithdraw}>
                  <div style={styles.formGrid}>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>العملة</label>
                      <select style={styles.input} value={form.currency_code} onChange={e => setForm({...form, currency_code: e.target.value})}>
                        {currencyList.map(c => <option key={c} value={c}>{c}</option>)}
                      </select>
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>المبلغ</label>
                      <input style={styles.input} type="number" value={form.amount} onChange={e => setForm({...form, amount: e.target.value})} placeholder="0" required />
                    </div>
                    <div style={{...styles.inputGroup, gridColumn: 'span 2'}}>
                      <label style={styles.label}>ملاحظات</label>
                      <input style={styles.input} value={form.notes} onChange={e => setForm({...form, notes: e.target.value})} placeholder="سبب السحب" />
                    </div>
                  </div>
                  <button style={{...styles.submitBtn, background: 'linear-gradient(135deg, #c62828, #e53935)'}} type="submit" disabled={loading}>
                    {loading ? 'جاري السحب...' : '📤 تأكيد السحب'}
                  </button>
                </form>
              </div>
            )}

            <div style={styles.balanceGrid}>
              {treasury.map((t, i) => (
                <div key={i} style={styles.balanceCard}>
                  <div style={styles.balanceCurrencyIcon}>
                    {t.currency_code === 'IQD' ? '🇮🇶' : t.currency_code === 'USD' ? '🇺🇸' : t.currency_code === 'GBP' ? '🇬🇧' : t.currency_code === 'EUR' ? '🇪🇺' : '💵'}
                  </div>
                  <div style={styles.balanceCurrency}>{t.currency_code}</div>
                  <div style={{
                    ...styles.balanceAmount,
                    color: parseFloat(t.balance) >= 0 ? '#2e7d32' : '#c62828',
                    fontSize: String(Math.round(parseFloat(t.balance))).length > 10 ? '14px' : String(Math.round(parseFloat(t.balance))).length > 7 ? '16px' : '20px'
                  }}>
                    {parseFloat(t.balance).toLocaleString()}
                  </div>
                  <div style={styles.balanceLabel}>الرصيد الحالي</div>
                </div>
              ))}
              {treasury.length === 0 && <div style={styles.empty}>لا توجد أرصدة</div>}
            </div>
          </div>

          {/* سجل الحركات */}
          <div style={styles.section}>
            <h2 style={styles.pageTitle}>📋 سجل الحركات المالية</h2>

            <div style={styles.searchCard}>
              <div style={styles.searchRow}>
                <input style={styles.searchInput} value={search}
                  onChange={e => setSearch(e.target.value)}
                  placeholder="🔍 بحث في الملاحظات، العملة، المستخدم، المبلغ..." />
                <button style={styles.clearBtn} onClick={() => { setSearch(''); setFilterSource('all'); setFilterType('all'); setFilterCurrency('all'); setFromDate(''); setToDate(''); }}>
                  مسح
                </button>
              </div>
              <div style={styles.filtersRow}>
                <div style={styles.filterGroup}>
                  <label style={styles.filterLabel}>المصدر</label>
                  <select style={styles.filterSelect} value={filterSource} onChange={e => setFilterSource(e.target.value)}>
                    <option value="all">الكل</option>
                    <option value="exchange">💱 صرافة</option>
                    <option value="transfer">💸 حوالة</option>
                    <option value="transfer_delivery">💸 تسليم حوالة</option>
                    <option value="debt">📋 مديونية</option>
                    <option value="manual">✋ يدوي</option>
                    <option value="customer_account">📒 حساب عميل</option>
                    <option value="client_payment">🏦 تسديد فرع</option>
                  </select>
                </div>
                <div style={styles.filterGroup}>
                  <label style={styles.filterLabel}>النوع</label>
                  <select style={styles.filterSelect} value={filterType} onChange={e => setFilterType(e.target.value)}>
                    <option value="all">الكل</option>
                    <option value="in">📥 دخول</option>
                    <option value="out">📤 خروج</option>
                    <option value="profit">💰 ربح</option>
                    <option value="deposit">🏦 إيداع</option>
                    <option value="withdraw">💸 سحب</option>
                  </select>
                </div>
                <div style={styles.filterGroup}>
                  <label style={styles.filterLabel}>العملة</label>
                  <select style={styles.filterSelect} value={filterCurrency} onChange={e => setFilterCurrency(e.target.value)}>
                    <option value="all">الكل</option>
                    {currencyList.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                <div style={styles.filterGroup}>
                  <label style={styles.filterLabel}>من تاريخ</label>
                  <input style={styles.filterDate} type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} />
                </div>
                <div style={styles.filterGroup}>
                  <label style={styles.filterLabel}>إلى تاريخ</label>
                  <input style={styles.filterDate} type="date" value={toDate} onChange={e => setToDate(e.target.value)} />
                </div>
                <div style={styles.filterResult}>
                  <span style={styles.filterResultText}>
                    النتائج: <strong>{filteredLog.length}</strong> |
                    دخول: <strong style={{color:'#2e7d32'}}>{totalIn.toLocaleString()}</strong> |
                    خروج: <strong style={{color:'#c62828'}}>{totalOut.toLocaleString()}</strong>
                  </span>
                </div>
              </div>
            </div>

            <div style={styles.tableCard}>
              <table style={styles.table}>
                <thead>
                  <tr style={styles.tableHead}>
                    <th style={styles.th}>النوع</th>
                    <th style={styles.th}>المصدر</th>
                    <th style={styles.th}>العملة</th>
                    <th style={styles.th}>المبلغ</th>
                    <th style={styles.th}>ملاحظات</th>
                    <th style={styles.th}>المستخدم</th>
                    <th style={styles.th}>التاريخ والوقت</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredLog.map((l, i) => {
                    const typeInfo = getTypeLabel(l.type);
                    return (
                      <tr key={l.id} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                        <td style={{...styles.td, color: typeInfo.color, fontWeight: 'bold'}}>{typeInfo.label}</td>
                        <td style={styles.td}>{getSourceLabel(l.source)}</td>
                        <td style={{...styles.td, fontWeight: 'bold', color: '#1a237e'}}>{l.currency_code}</td>
                        <td style={{...styles.td, fontWeight: 'bold', color: typeInfo.color}}>
                          {parseFloat(l.amount).toLocaleString()}
                        </td>
                        <td style={{...styles.td, fontSize: '12px', color: '#666'}}>{l.notes || '-'}</td>
                        <td style={styles.td}>{l.username || '-'}</td>
                        <td style={{...styles.td, fontSize: '12px', color: '#666'}}>{formatDateTime(l.created_at)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {filteredLog.length === 0 && <div style={styles.empty}>لا توجد نتائج</div>}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

const styles = {
  container: { minHeight: '100vh', background: '#f5f5f5' },
  navbar: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', padding: '15px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  navTitle: { color: 'white', fontSize: '20px' },
  logoutBtn: { background: 'rgba(255,255,255,0.2)', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer' },
  layout: { display: 'flex' },
  sidebar: { width: '200px', background: 'white', minHeight: 'calc(100vh - 60px)', padding: '20px 0', boxShadow: '2px 0 5px rgba(0,0,0,0.1)' },
  sideItem: { display: 'block', padding: '12px 20px', color: '#333', textDecoration: 'none', fontSize: '14px', borderBottom: '1px solid #f0f0f0' },
  content: { flex: 1, padding: '30px' },
  section: { marginBottom: '30px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  pageTitle: { color: '#1a237e', fontSize: '22px', marginBottom: '15px' },
  depositBtn: { background: 'linear-gradient(135deg, #1b5e20, #2e7d32)', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  withdrawBtn: { background: 'linear-gradient(135deg, #c62828, #e53935)', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  formCard: { background: 'white', borderRadius: '12px', padding: '25px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', borderRight: '4px solid #2e7d32' },
  formTitle: { marginBottom: '15px', color: '#1a237e' },
  formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px' },
  inputGroup: {},
  label: { display: 'block', marginBottom: '6px', color: '#333', fontSize: '14px', fontWeight: 'bold' },
  input: { width: '100%', padding: '10px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', direction: 'rtl' },
  submitBtn: { background: 'linear-gradient(135deg, #1b5e20, #2e7d32)', color: 'white', border: 'none', padding: '12px 30px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  balanceGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '20px', marginBottom: '20px' },
  balanceCard: { background: 'white', borderRadius: '16px', padding: '25px 20px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', textAlign: 'center', borderTop: '4px solid #1a237e' },
  balanceCurrencyIcon: { fontSize: '32px', marginBottom: '8px' },
  balanceCurrency: { fontSize: '18px', fontWeight: 'bold', color: '#1a237e', marginBottom: '10px' },
  balanceAmount: { fontWeight: 'bold', marginBottom: '8px', wordBreak: 'break-all', lineHeight: '1.3' },
  balanceLabel: { fontSize: '11px', color: '#999', background: '#f5f5f5', padding: '3px 10px', borderRadius: '10px', display: 'inline-block' },
  searchCard: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '15px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  searchRow: { display: 'flex', gap: '10px', marginBottom: '15px' },
  searchInput: { flex: 1, padding: '10px 15px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', direction: 'rtl' },
  clearBtn: { background: '#666', color: 'white', border: 'none', padding: '10px 15px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  filtersRow: { display: 'flex', gap: '15px', alignItems: 'flex-end', flexWrap: 'wrap' },
  filterGroup: { display: 'flex', flexDirection: 'column', gap: '4px' },
  filterLabel: { fontSize: '12px', color: '#666', fontWeight: 'bold' },
  filterSelect: { padding: '8px 12px', border: '1px solid #e0e0e0', borderRadius: '6px', fontSize: '13px' },
  filterDate: { padding: '8px 12px', border: '1px solid #e0e0e0', borderRadius: '6px', fontSize: '13px' },
  filterResult: { display: 'flex', alignItems: 'center' },
  filterResultText: { fontSize: '13px', color: '#666' },
  tableCard: { background: 'white', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  table: { width: '100%', borderCollapse: 'collapse' },
  tableHead: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)' },
  th: { padding: '12px 15px', color: 'white', textAlign: 'right', fontSize: '13px' },
  trEven: { background: 'white' },
  trOdd: { background: '#f8f9fa' },
  td: { padding: '10px 15px', fontSize: '13px', borderBottom: '1px solid #f0f0f0' },
  empty: { textAlign: 'center', padding: '40px', color: '#999' },
};

export default Treasury;